(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery', 'torso/modules/Collection', './LocationModel', 'services/locationExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var locationExtService = require('./../urls').locationExtService;
    module.exports = factory(require('jquery'), require('backbone-torso/modules/Collection'), require('./LocationModel'), locationExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function($, TorsoCollection, LocationModel, locationExtService) {
  'use strict';

  /**
   * Receives locations from the LocationExtService which serves the LocationDTO resource
   * @class LocationCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: LocationModel,
    url: locationExtService,
    fetchHttpAction: 'POST',

    /**
     * @method fetchAllCodes
     * @return {jQuery.Deferred.Promise} that resolves to the list of all location codes on the server.
     */
    fetchAllCodes: function() {
      return $.ajax({
        url: locationExtService,
        contentType: 'application/json',
        type: 'GET',
        dataType: 'json'
      });
    }
  }))();
}));
